import { storeName } from './types';

const getStore = state => state[storeName] || {};
const isInitialized = state => getStore(state).initialized || false;
const getSettings = state => getStore(state).settings || {};

export default {
    getStore,
    isInitialized,
    getSettings,
};
